<template>
  <ul>
    <li v-for="dataEntry in dataObject" v-bind:key="dataEntry.index">
      <div v-if="dataEntry.approved">

        <div v-if="dataEntry.file !== null">
          <img v-if="!checkIfPdf(dataEntry.file)" :src="replaceLocalhost(dataEntry.file)" class="grid__item" alt="upload gallery entry">
          <a v-else :href="replaceLocalhost(dataEntry.file)">
            <img :src="pdfIconPath" class="grid__item" alt="upload gallery entry">
          </a>
        </div>

        <div class="comment">
          <p>{{ dataEntry.comment }}</p>
        </div>

        <span>{{ dataEntry.gate_name }}</span>

      </div>
    </li>
  </ul>
</template>

<script>
import {
  apiService
} from "@/common/api.service";

export default {
  name: "GetContent",
  data() {
    return {
      contentEndpoint: 'https://api.greenhamwomen.digital/plenum/contribution/',
      dataObject: null,
      pdfIconPath: '/images/gwd-pdf.png'
    }
  },

  methods: {
    retrieveImageEntries() {
      let endpoint = this.contentEndpoint;
      apiService(endpoint).then(data => {
        if (data) {
          this.dataObject = data
          //console.log(data);
        } else {
          console.log('could not fetch it');
        }
      })
    },
    replaceLocalhost(receivedUri) {
      let mediaAddress = receivedUri.replace("http://127.0.0.1:8000/", "https://api.greenhamwomen.digital/")
      return mediaAddress
    },

    checkIfPdf(filePassed){
      //console.log(filePassed.split('.').pop())
      return filePassed.split('.').pop() === 'pdf' || filePassed.split('.').pop() === 'PDF'
    }
  },
  mounted() {
    this.retrieveImageEntries()
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  padding-left: 0;
}

li {
  padding: 0 0 2em 0;
}

.comment p {
  margin: .1em 0 .2em;
  font-size: .65em;
}

img {
  width: 100%;
}

span {
  font-size: .7em;
  padding: .07em .5em;
  border-radius: .25em;
  border: 1px solid var(--darkest);
  margin-right: 1em;
}

@media screen and (min-width: 660px) {
    ul {
      display: grid;
      grid-gap: 1em;
      grid-template-columns: repeat(2, minmax(1px, 100%));
      padding: 1em;
      list-style: none;
      overflow: auto;
      align-items: center;
    }
}

@media screen and (min-width: 1200px) {
    ul {
      grid-gap: 1em;
      grid-template-columns: repeat(3, minmax(1px, 100%));
      padding: 1em;
    }
}

@media screen and (min-width: 1800px) {
    ul {
      grid-gap: 1em;
      grid-template-columns: repeat(4, minmax(1px, 100%));
      padding: 1em;
    }
}

</style>
